// extracted by mini-css-extract-plugin
export default {"item":"Item_item__dAROk","anchor":"Item_anchor__CKrkx","title":"Item_title__Qqba0"};